<template>
  <div class="powered-by v2hur" :class="{ 'powered-by_mt20': marginTop }">
    <img v-if="partnerLogo" class="powered-by__icon" :src="partnerLogo" alt="logo" id="logoPartner" />
    <div v-if="!disablePoweredBy">
      <span class="powered-by__separator" v-if="partnerLogo"> | </span>
      {{ $t("powered-by") }}
      <a class="powered-by__link" :href="rocketfuelUrl" target="_blank">
        <!-- {{ $t('rocketfuel') }} -->
        <!-- {{poweredBy}} -->
        <img class="powered-by__icon" :src="require('@/assets/img/logo.svg')" alt="logo" id="logo" />
        <b-tooltip target="logo" triggers="hover" placement="top" class="tip">
          {{ poweredBy }}
        </b-tooltip>
      </a>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    marginTop: Boolean,
  },
  computed: {
    ...mapGetters({
      marketInfo: "user/marketInfo",
    }),
    poweredBy() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.partnerLabel
      ) {
        return this.marketInfo.whiteLabel.colorSchema.partnerLabel;
      }
      return "Rocketfuel";
    },
    rocketfuelUrl() {
      return "https://rocketfuelblockchain.com/";
    },
    poweredUrl() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.partnerUrl
      ) {
        return this.marketInfo.whiteLabel.colorSchema.partnerUrl;
      }
      return "https://rocketfuelblockchain.com/";
    },
    partnerLogo() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.logo
      ) {
        return this.marketInfo.whiteLabel.colorSchema.logo;
      }
      return "";
    },
    disablePoweredBy() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema
      ) {
        return this.marketInfo.whiteLabel.colorSchema.disablePoweredBy;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.powered-by {
  width: 100%;
  font-weight: 300;
  font-size: 12px;
  line-height: 23px;
  color: $black400;
  background: #efefef;
  text-align: center;
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  left: 0;
  align-items: center;

  &_mt20 {
    margin-top: 20px;
  }

  &__link {
    margin-left: 5px;
    text-decoration: underline;
    font-weight: 700;

    &:hover {
      text-decoration: none;
    }
  }

  &__separator {
    padding-left: 10px;
    padding-right: 10px;
  }

  &__icon {
    width: 20px;
    height: 20px;
    margin-left: 5px;
    padding: 1px;
  }

  @media (max-width: 480px) {
    position: absolute;
    bottom: 0;
  }
}
</style>
